import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

const API_BASE = process.env.REACT_APP_API_URL;

export default function QualityObsoletePage() {
  const { getToken } = useAuth();
  const navigate = useNavigate();
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const token = await getToken();
      const res = await fetch(`${API_BASE}/quality/documents?status=Obsolete`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.ok) setDocs(data.documents || []);
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  }, [getToken]);

  useEffect(() => { load(); }, [load]);

  const LEVEL_LABELS = { MASTER: 'Master', FAMILY: 'Family', SPECIFIC: 'Specific' };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>Obsolete Documents</h2>
        <p style={{ color: 'var(--ni-text-muted)', fontSize: 13, marginTop: 6 }}>
          Decommissioned procedures. Read-only — retained for historical traceability.
        </p>
      </div>

      <div style={{ background: 'var(--ni-panel)', border: '1px solid var(--ni-border-soft)', borderRadius: 10, overflow: 'hidden' }}>
        {loading ? (
          <div style={{ padding: 40, color: 'var(--ni-text-muted)', textAlign: 'center' }}>Loading...</div>
        ) : docs.length === 0 ? (
          <div style={{ padding: 40, color: 'var(--ni-text-muted)', textAlign: 'center', fontSize: 14 }}>
            No obsolete documents.
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ color: 'var(--ni-text-muted)', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em', background: 'rgba(0,0,0,0.2)' }}>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600 }}>Doc No.</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600 }}>Title</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600 }}>Level</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600 }}>Last Rev.</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600 }}>Obsolete Date</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600 }}>Reason</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600 }}>Replaced By</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600 }}>Owner</th>
                </tr>
              </thead>
              <tbody>
                {docs.map(doc => (
                  <tr
                    key={doc._id}
                    onClick={() => navigate(`/quality/documents/${doc._id}`)}
                    style={{ cursor: 'pointer', borderTop: '1px solid var(--ni-border-soft)', opacity: 0.8 }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.03)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <td style={{ padding: '11px 16px', fontFamily: 'monospace', fontSize: 12, color: 'var(--ni-text-muted)', whiteSpace: 'nowrap' }}>{doc.documentNumber}</td>
                    <td style={{ padding: '11px 16px', fontWeight: 600, maxWidth: 300 }}>{doc.title}</td>
                    <td style={{ padding: '11px 16px', color: 'var(--ni-text-muted)' }}>
                      <span style={{
                        fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 4, textTransform: 'uppercase',
                        background: 'rgba(100,116,139,0.15)', color: '#64748b',
                      }}>
                        {LEVEL_LABELS[doc.level] || doc.level}
                      </span>
                    </td>
                    <td style={{ padding: '11px 16px', color: 'var(--ni-text-muted)', fontFamily: 'monospace' }}>{doc.currentRevision || '—'}</td>
                    <td style={{ padding: '11px 16px', color: 'var(--ni-text-muted)', whiteSpace: 'nowrap' }}>
                      {doc.obsoleteDate ? new Date(doc.obsoleteDate).toLocaleDateString() : '—'}
                    </td>
                    <td style={{ padding: '11px 16px', color: 'var(--ni-text-muted)', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {doc.obsoleteReason || '—'}
                    </td>
                    <td style={{ padding: '11px 16px', fontFamily: 'monospace', fontSize: 12, color: 'var(--ni-green)' }}>
                      {doc.replacementDocumentId || '—'}
                    </td>
                    <td style={{ padding: '11px 16px', color: 'var(--ni-text-muted)' }}>{doc.owner || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div style={{ marginTop: 10, color: 'var(--ni-text-muted)', fontSize: 12 }}>{docs.length} obsolete document{docs.length !== 1 ? 's' : ''}</div>
    </div>
  );
}
